<template>
  <div class="card">
    <div class="card-content">
      <div class="row">
        <div class="col-xs-5">
          <slot name="header"></slot>
        </div>
        <div class="col-xs-7">
          <slot name="content"></slot>
        </div>
        <div class="col-xs-12 col-md-12">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'stats-card'
  }

</script>
<style scoped>
  .card-content{
    min-height: 85px
  }
  .col-xs-5{
    padding-right: 10px;
    padding-left: 50px;
  }
  .col-xs-4{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Cards/StatsCard.vue